<template>
    <div v-if="statistics && statistics.totals">
        <div v-for="team_statistics in statistics.totals.competitors" :key="team_statistics.id">

            <h4>{{ team_statistics.name }} ({{ team_statistics.qualifier }})</h4>

            <table class="table">
                <tr>
                    <th>Team statistics</th>
                    <th>Players statistics</th>
                </tr>
                <tr>
                    <td>
                        <div v-if="team_statistics.statistics">
                            ball_possession: {{ team_statistics.statistics.ball_possession }}<br>
                            corner_kicks: {{ team_statistics.statistics.corner_kicks }}<br>
                            fouls: {{ team_statistics.statistics.fouls }}<br>
                            free_kicks: {{ team_statistics.statistics.free_kicks }}<br>
                            goal_kicks: {{ team_statistics.statistics.goal_kicks }}<br>
                            injuries: {{ team_statistics.statistics.injuries }}<br>
                            offsides: {{ team_statistics.statistics.offsides }}<br>
                            penalties_missed: {{ team_statistics.statistics.penalties_missed }}<br>
                            shots_blocked: {{ team_statistics.statistics.shots_blocked }}<br>
                            shots_off_target: {{ team_statistics.statistics.shots_off_target }}<br>
                            shots_on_target: {{ team_statistics.statistics.shots_on_target }}<br>
                            shots_saved: {{ team_statistics.statistics.shots_saved }}<br>
                            throw_ins: {{ team_statistics.statistics.throw_ins }}<br>
                            yellow_cards: {{ team_statistics.statistics.yellow_cards }}<br>
                        </div>
                        
                    </td>
                    <td>
                        <table>
                            <tr v-for="player_statistics in team_statistics.players" :key="player_statistics.id">
                                <td>
                                    {{ player_statistics.name }}
                                </td>
                                <td>
                                    <span v-if="player_statistics.statistics.assists">assists: {{ player_statistics.statistics.assists }}<br></span>
                                    <span v-if="player_statistics.statistics.goals_scored">goals_scored: {{ player_statistics.statistics.goals_scored }}<br></span>
                                    <span v-if="player_statistics.statistics.own_goals">own_goals: {{ player_statistics.statistics.own_goals }}<br></span>
                                    <span v-if="player_statistics.statistics.red_cards">red_cards: {{ player_statistics.statistics.red_cards }}<br></span>
                                    <span v-if="player_statistics.statistics.substituted_in">substituted_in: {{ player_statistics.statistics.substituted_in }}<br></span>
                                    <span v-if="player_statistics.statistics.substituted_out">substituted_out: {{ player_statistics.statistics.substituted_out }}<br></span>
                                    <span v-if="player_statistics.statistics.yellow_cards">yellow_cards: {{ player_statistics.statistics.yellow_cards }}<br></span>
                                    <span v-if="player_statistics.statistics.yellow_red_cards">yellow_red_cards: {{ player_statistics.statistics.yellow_red_cards }}<br></span>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresMatchStatistics',
    props: {
        statistics: ''
    }
}
</script>

